import { Dialog } from '@mui/material';
import { useState } from 'react';
import { useStoreSelector } from 'v3/data/store';
import { FlexButton } from 'v3/shared/components/Button/FlexButton';
import { SearchInput } from 'v3/shared/components/Inputs/SearchInput';
import {
  AlignRowBetween,
  CloseIconStyled,
  Container,
  Content,
  dialogStyles,
  DividerStyled,
  Footer,
  Header,
  StoreListInformationContainer,
} from './styles';
import { DialogMultiDataSelectProps } from './types';

import { setSellerStoreIdsListFilter } from 'v3/data/store/seller/actions';
import { Stores } from 'v3/shared/components/Filters/StoreSellerFilter/Store';
import { LabelSmall, LabelSmallBold } from 'v3/shared/typography/LabelSmall';
import { TitleLargeBold } from 'v3/shared/typography/TitleLarge';
import { theme } from 'v3/styles/global-styles';

export const DialogMultiDataSelect: React.FC<DialogMultiDataSelectProps> = ({
  setOpen,
  open,
  title,
  hideSearch,
  setOpenModal,
}) => {
  const [search, setSearch] = useState<string>('');
  const { storeList } = useStoreSelector((store) => store.seller);
  const selectedStoreIds = storeList.filter((store) => store.checked).map((store) => store.id);

  const handleClose = () => {
    setOpen(false);
    setSearch('');
  };

  const handleFilter = () => {
    setOpenModal(false);
    setSellerStoreIdsListFilter(selectedStoreIds);
  };

  return (
    <Dialog
      onClose={handleClose}
      open={open}
      PaperProps={{
        sx: dialogStyles(theme),
      }}
    >
      <Container>
        <Header>
          <AlignRowBetween>
            <TitleLargeBold>{title}</TitleLargeBold>
            <CloseIconStyled onClick={handleClose} />
          </AlignRowBetween>

          {!hideSearch && (
            <SearchInput
              name="search"
              value={search}
              label={title}
              placeholder={'Procurar por nome da loja ou CNPJ'}
              onChange={(value) => setSearch(value)}
              onKeyDown={(event) => {
                if (event.key !== 'Escape') event.stopPropagation();
              }}
            />
          )}
        </Header>
        <Content>
          <Stores searchValue={search} />
        </Content>

        <DividerStyled />

        <Footer>
          <StoreListInformationContainer>
            <LabelSmall>
              <LabelSmallBold>{selectedStoreIds.length}</LabelSmallBold> lojas de {storeList.length} lojas selecionadas
            </LabelSmall>
          </StoreListInformationContainer>
          <FlexButton
            text="Filtrar lojas selecionadas"
            size="small"
            handleClick={() => {
              handleFilter();
              handleClose();
            }}
          />
        </Footer>
      </Container>
    </Dialog>
  );
};
